import { configureStore } from "@reduxjs/toolkit";
import eventReducer from "../Reducers/eventReducer";
import CrmSlice from "../Reducers/CrmSlice";
import OrderSlice from "../Reducers/OrderSlice";
import ProductSlice from "../Reducers/ProductSlice";
import WarehouseSlice from "../Reducers/WarehouseSlice";
import ContactsSlice from "../Reducers/ContactsSlice";
import UsersSlice from "../Reducers/UsersSlice";
import CompanySlice from "../Reducers/CompanySlice";
import SubscriptionSlice from "../Reducers/SubscriptionSlice";
import CategoriesSlice from "../Reducers/CategoriesSlice";
import BrandsSlice from "../Reducers/BrandsSlice";
import AttributesSlice from "../Reducers/AttributesSlice";

const store = configureStore({
  reducer: {
    events: eventReducer,
    crm: CrmSlice,
    order: OrderSlice,
    product: ProductSlice,
    category: CategoriesSlice,
    brand: BrandsSlice,
    attribute: AttributesSlice,
    warehouse: WarehouseSlice,
    contacts: ContactsSlice,
    users: UsersSlice,
    company: CompanySlice,
    subscription: SubscriptionSlice,
  },
  devTools: true,
});

export default store;
